import { useSelector } from 'react-redux';
import { useDeviceType } from '../hooks/useDeviceType';

export function Hint() {
  const { message, isDisplay } = useSelector((state) => state.hint);
  const { isShowSharing, isReview } = useSelector((state) => state.ui);
  const device = useDeviceType();
  const isMobile = device === 'mobile';

  const isHintOpen = !isReview && !isShowSharing && isDisplay;

  return isHintOpen ? (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '4px',
        position: 'absolute',
        bottom: isMobile ? '5px' : '16px',
        width: '100%',
      }}
    >
      <img src="/theme/img/iconLight.svg" alt="iconLight" />
      <p
        style={{
          fontSize: isMobile ? '12px' : '16px',
          lineHeight: '20px',
          color: '#C2C3CC',
          margin: 0,
        }}
      >
        {/* Select a pattern, then choose an area to change its pattern. */}
        {message}
      </p>
    </div>
  ) : (
    <></>
  );
}
